<script setup lang="ts">
// (format: https://calendar.google.com/calendar/appointments/schedules/AcZssZ.../?gv=true)
const BOOKING_URL = 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0A_B9nfJ0a2SkNOpg3rNwgXYj9fmE1lpOuMoyW9D_RiKpltA_N1tCMTgqifwR66fGdEUCwDERZ?gv=true'
</script>

<template>
  <section id="rendez-vous" class="relative overflow-hidden py-24 px-6 md:px-12">
    <div class="absolute inset-0 pointer-events-none" aria-hidden="true">
      <div class="dandelion dandelion-2 absolute top-[8%] right-[5%] w-28 h-36 sm:w-36 sm:h-44 rotate-[-6deg]" />
      <div class="dandelion dandelion-3 absolute bottom-[10%] left-[4%] w-24 h-32 sm:w-32 sm:h-40 rotate-[8deg]" />
    </div>
    <div class="relative max-w-5xl mx-auto flex flex-col gap-8">
      <div class="flex flex-col gap-3 text-center">
        <p class="uppercase tracking-[0.3em] text-sm text-terracotta-600 dark:text-terracotta-400 font-medium">Réserver
          en ligne</p>
        <h2 class="text-3xl md:text-4xl text-stone-900 dark:text-stone-50">Prendre rendez-vous</h2>
        <p class="text-base md:text-lg text-stone-600 dark:text-stone-300 leading-relaxed max-w-2xl mx-auto">
          Choisissez un créneau parmi mes disponibilités&nbsp;: votre demande me parvient directement.
        </p>
      </div>

      <div
        class="rounded-xl bg-white/70 dark:bg-stone-900/60 border border-stone-200 dark:border-stone-800 backdrop-blur-sm p-2 md:p-4">
        <iframe :src="BOOKING_URL" title="Calendrier de prise de rendez-vous avec Nathalie Gottvalles" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade" class="w-full h-[700px] md:h-[780px] rounded-lg border-0" />
      </div>

      <p class="text-sm text-stone-500 dark:text-stone-400 text-center">
        <a :href="BOOKING_URL" target="_blank" rel="noopener"
          class="text-terracotta-700 dark:text-terracotta-300 hover:underline">
          Ouvrir le calendrier dans un nouvel onglet
          <i class="pi pi-external-link text-xs ml-1" aria-hidden="true" />
        </a>
      </p>
    </div>
  </section>
</template>
